import { createAction } from 'redux-actions';

export const getVehicles = createAction('GET_VEHICLES');
export const getVehiclesSuccess = createAction('GET_VEHICLES_SUCCESS');
export const getVehiclesFailure = createAction('GET_VEHICLES_FAILURE');

export const createVehicle = createAction('CREATE_VEHICLE', (payload) => payload, (payload, metadata) => metadata);
export const createVehicleSuccess = createAction('CREATE_VEHICLE_SUCCESS', (payload) => payload, (payload, metadata) => metadata);
export const createVehicleFailure = createAction('CREATE_VEHICLE_FAILURE');

export const updateVehicle = createAction('UPDATE_VEHICLE', (payload) => payload, (payload, metadata) => metadata);
export const updateVehicleSuccess = createAction('UPDATE_VEHICLE_SUCCESS');
export const updateVehicleFailure = createAction('UPDATE_VEHICLE_FAILURE');

export const deleteVehicle = createAction('DELETE_VEHICLE', (payload) => payload, (payload, metadata) => metadata);
export const deleteVehicleSuccess = createAction('DELETE_VEHICLE_SUCCESS');
export const deleteVehicleFailure = createAction('DELETE_VEHICLE_FAILURE');
